import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cqtxnt1b: FaireBrandEntity = {
  token: "b_cqtxnt1b",
  type: "brand",
  name: "Commonwealth Provisions",
  avatarUrl:
    "https://cdn.faire.com/fastly/f8aa2c7782f217ed9ec720b34b61bdf4f00bd4cf3b882d4c65e65571f4f088bd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/cd87bec9081b71ae77a65e13ba9113ffcbb2218b7f4ed33675bb42921330f0e3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f8aa2c7782f217ed9ec720b34b61bdf4f00bd4cf3b882d4c65e65571f4f088bd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cd87bec9081b71ae77a65e13ba9113ffcbb2218b7f4ed33675bb42921330f0e3.jpeg",
  location: "Fredericksburg, VA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 104,
  isTopShop: true,
  isInsider: true,
  description:
    "Commonwealth Provisions started back in 2017 when Luke Smith decided to turn a hobby into something more. He was working a corporate job at the time but had a dream of building something hands-on and personal. So he started making candles.\n\nThat first candle was the beginning of it all. Along with it came a promise: 10% of profits would go to animal rescue. That’s been true since day one and it’ll stay that way until the last product we ever make.\n\nSince then, we’ve added more products and grown quite a bit. You can now find our goods in boutiques across 40+ states, but we’re still a super small team of three. Everything we make ships straight from our studio in Fredericksburg, Virginia. No big factories. No fluff. Just thoughtful goods made by hand that help to make life just a little bit better.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:10.547Z",
    importedBy: "entity-db-cli",
  },
};
